"use client";

import React from "react";
import Image from "next/image";
import "./PostMeta.scss";

export interface PostMetaProps {
  publishedAt: string | Date;
  viewCount?: number;
  className?: string;
}

/**
 * Format date to Vietnamese format
 * @param date - Date string or Date object
 * @returns Formatted date string (e.g., "3 tháng 4, 2026")
 */
function formatVietnameseDate(date: string | Date): string {
  const dateObj = typeof date === "string" ? new Date(date) : date;
  
  if (isNaN(dateObj.getTime())) {
    return "";
  }

  const day = dateObj.getDate();
  const month = dateObj.getMonth() + 1;
  const year = dateObj.getFullYear();

  return `${day} tháng ${month}, ${year}`;
}

/**
 * PostMeta Component
 * Displays post metadata including published date and view count
 */
export default function PostMeta({
  publishedAt,
  viewCount,
  className = "",
}: PostMetaProps) {
  const formattedDate = formatVietnameseDate(publishedAt);

  return (
    <div className={`post-meta ${className}`}>
      <div className="post-meta__item">
        <Image
          alt="Calendar icon"
          loading="lazy"
          width={16}
          height={16}
          className="post-meta__icon"
          src="/assets/svg/calendar-brand-color.svg"
        />
        <span className="post-meta__text">{formattedDate}</span>
      </div>
      
      {viewCount !== undefined && (
        <div className="post-meta__item">
          <span className="post-meta__text">👁 {viewCount} lượt xem</span>
        </div>
      )}
    </div>
  );
}
